module.exports = __webpack_public_path__ + "static/media/course_02.541042f1.png";